export class QrFormModel {
  constructor(
    public fullName = '',
    public documentType =  '',
    public documentNumber = '',
    public cellphone = '',
    public email = '',
  ) {
  }
}

export interface RequestGeneratedQR{
  celphone: string;
  email: string;
  fullname: string;
  document_type: string;
  document_number: string;
}

export interface ResponseGeneratedQr {
  CODE: string;
  DESC: string;
  DATA: BancolombiaQr;
}

export interface BancolombiaQr {
  qrImage: string;
}
